import type { Node, NodeProps } from "@xyflow/react";

import { Badge } from "@/components/ui/badge";
import { formatCurrency, formatStatusLabel } from "@/lib/format";
import { getPaymentStatusBadgeClass } from "@/lib/status-tag-colors";

import { FlowNodeCard, FlowNodeRow, LeftTargetHandle } from "./shared";
import type { PaymentNodeData } from "./types";

type PaymentFlowNode = Node<PaymentNodeData, "payment">;

export function PaymentNode({ data }: NodeProps<PaymentFlowNode>) {
  return (
    <>
      <LeftTargetHandle />
      <FlowNodeCard
        title="Payment"
        rightSlot={
          <Badge variant="outline" className={getPaymentStatusBadgeClass(data.status)}>
            {formatStatusLabel(data.status, "Unknown")}
          </Badge>
        }
      >
        <FlowNodeRow
          label="Amount"
          value={typeof data.amount === "number" ? formatCurrency(data.amount) : "-"}
        />
        <FlowNodeRow label="Type" value={formatStatusLabel(data.paymentType, "-")} />
        <FlowNodeRow
          label="Transaction"
          value={
            data.transactionId ? (
              <span
                className="block break-all font-mono text-[11px] leading-4"
                title={data.transactionId}
              >
                {data.transactionId}
              </span>
            ) : (
              "-"
            )
          }
          valueClassName="max-w-[140px]"
        />
      </FlowNodeCard>
    </>
  );
}
